var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"igrala-background"},[(_vm.title)?_c('h3',{staticClass:"igrala-desc-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('p',{staticClass:"igrala-desc-text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.description)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }